import { FieldHookConfig, useField } from 'formik'
import { Checkbox, CheckboxProps, FormControlLabel } from '@mui/material'

interface Props extends Omit<CheckboxProps, 'variant'> {
  label?: string
}

export default function InputFormikCheckbox(
  props: Props & FieldHookConfig<boolean>,
) {
  const [field, , helpers] = useField(props)

  const { label, disabled } = props

  return (
    <FormControlLabel
      control={
        <Checkbox
          disabled={disabled}
          name="status"
          checked={field.value}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            helpers.setValue(e.target.checked)
          }
        />
      }
      label={label || ''}
    />
  )
}
